/**
 * 患者管理模块路由配置
 *
 * @module patient-management/routes
 */
import { RouteRecordRaw } from "vue-router";

// 懒加载主视图
const PatientManagementView = () =>
  import("./shared/interfaces/PatientManagementView.vue");

export const patientManagementRoutes: RouteRecordRaw[] = [
  {
    path: "/patient-management",
    name: "PatientManagement",
    component: PatientManagementView,
    meta: {
      title: "患者管理（DDD）",
      requiresAuth: true,
      keepAlive: true,
      breadcrumb: ["首页", "患者管理"],
    },
  },
];

export default patientManagementRoutes;
